/**
 * Utilidades de país. Usa fallback estático mínimo.
 * Para datos desde BD, usar useCountries() o getCountries() de @/shared/config/countries.
 */

const FALLBACK: Record<string, { name: string; flag: string; isoCode: string }> =
  {
    RD: { name: "República Dominicana", flag: "🇩🇴", isoCode: "do" },
    MX: { name: "México", flag: "🇲🇽", isoCode: "mx" },
    CO: { name: "Colombia", flag: "🇨🇴", isoCode: "co" },
    CL: { name: "Chile", flag: "🇨🇱", isoCode: "cl" },
    PE: { name: "Perú", flag: "🇵🇪", isoCode: "pe" },
    US: { name: "Estados Unidos", flag: "🇺🇸", isoCode: "us" },
  };

export const getISOCountryCode = (code: string): string =>
  FALLBACK[code?.toUpperCase()]?.isoCode ?? code?.toLowerCase() ?? "";

export const getCountryName = (code: string): string =>
  FALLBACK[code?.toUpperCase()]?.name ?? code ?? "";

export const getCountryFlagEmoji = (code: string): string =>
  FALLBACK[code?.toUpperCase()]?.flag ?? "";
